import React from 'react'
import { arrayOf, node, oneOf, oneOfType, shape, string } from 'prop-types'
import classNames from 'classnames'
import Logo from '../logo'
import FooterSection from './footer-section'
import style from './index.scss'
import Paragraph from '../../scentregroup-ui/components/paragraph'

const SUSTAINABILITY_PAGE = 'http://scentregroup.com/sustainability'

const SiteFooter = ({ className, content, links, logoUrl }) => {
  return (
    <footer
      className={classNames(style.siteFooter, className, {})}
      role="contentinfo"
    >
      <div className={style.container}>
        {content && <FooterSection>{content}</FooterSection>}
        <FooterSection className={style.content}>
          <Logo type={'westfield-red'} className={style.logo} url={logoUrl} />
          <div className={style.disclaimer}>
            Scentre Group operates its Westfield destinations with a responsible
            and sustainable mindset, aiming to deliver meaningful outcomes
            across three priorities including: Customer and communities, People,
            and Environment. More information can be found on the Scentre Group{' '}
            <a
              href={SUSTAINABILITY_PAGE}
              target="_blank"
              rel="noopener noreferrer"
            >
              sustainability page
            </a>
            .
          </div>
          {links && (
            <ul className={style.linksList}>
              {links.map(({ label, href }) => (
                <li key={href}>
                  <a
                    href={href}
                    className={style.footerLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          )}
          <Paragraph className={style.rightsText}>
            <span>© All rights reserved </span>
            <a
              href="https://www.scentregroup.com"
              className={classNames(style.footerLink, style.rightsTextLink)}
            >
              Scentre Group
            </a>
            <span> {new Date().getFullYear()}</span>
          </Paragraph>
        </FooterSection>
      </div>
      <div className={style.banner}></div>
    </footer>
  )
}

SiteFooter.propTypes = {
  className: string,
  colour: oneOf(['brand', 'seasonal']),
  content: oneOfType([arrayOf(node), node]),
  links: arrayOf(
    shape({
      label: string.isRequired,
      href: string.isRequired,
    })
  ),
  logoUrl: string,
}

SiteFooter.defaultProps = {
  className: null,
  colour: 'seasonal',
  links: [],
  logoUrl: null,
}

export default SiteFooter
